import uiReducer from './reducer';

export default uiReducer;

export { isSelectingCustomer } from './selectors';



// WEBPACK FOOTER //
// ./src/store/ui/index.js